module.exports = __webpack_public_path__ + "static/img/login-bg.d0f1dcec.png";